<template>
  <div class="data-input" :class="{'custom-value': hasValueSlot}">
    <!--
      数据值输入框，和data-column差不多，但data-column不能编辑，data-input可以编辑。
      ★ 传入默认插槽时，值区域改用插槽内容，自带控件的点击/抽屉都不渲染 ——
        用于「选择类 / 日期类」等不能走文本抽屉的控件，好处是整张表单的行样式统一。
      ★ 注释必须写在根元素「里面」：写在 template 顶层会让组件变成多根节点，
        $el 会变成 fragment 的锚点文本节点（没有 getBoundingClientRect）。
    -->
    <div class="data-label">
      <slot name="label">{{label}}</slot>
    </div>
    <!-- 自定义控件：由控件自己处理点击，不走文本抽屉 -->
    <div v-if="hasValueSlot" class="data-value">
      <slot/>
    </div>
    <template v-else>
      <div class="data-value" @click="toShowDrawer">
        <span v-if="value !== '' && value !== undefined">{{value}}</span>
        <span class="placeholder" v-else>{{placeholder}}</span>
      </div>
    </template>
    <!--
      箭头始终渲染：用插槽放自定义控件（选择类 / 日期类）的行也要有，
      否则同一张表里「有的行有箭头、有的没有」，看着不统一。
      相应地，插槽里的控件要把自带的箭头关掉，避免一行出现两个箭头。
    -->
    <div class="arrow" :class="disabled? 'disabled': ''">
      <slot name="suffix">
        <yq-icon name="element-ui_arrow-right" rotate-z="90deg"/>
      </slot>
    </div>
    <el-drawer v-if="!hasValueSlot" append-to-body direction="btt" size="80%" v-model="showDrawer">
      <template #header>
        <div class="drawer-title">编辑{{label}}</div>
      </template>
      <div class="input-container">
        <el-input class="input-area" type="textarea" v-model="currentValue" autosize/>
        <div class="input-desc">{{desc}}</div>
        <mobile-button class="input-button" el-type="primary" @click="toConfirmChange">确认</mobile-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import {watch} from "vue";
import YqIcon from "@/components/YqIcon.vue";
import MobileButton from "@/components/qywx/button/MobileButton.vue";

export default {
  emits: ["update:modelValue", "change"],
  props: {
    label: {default: ''},
    disabled: {default: false}, // 只读
    modelValue: {default: ""},
    placeholder: {default: ''},
    // 抽屉里的说明文字：原来默认是一句占位用的示例文案，谁都没传 desc，于是每个抽屉都显示它，改成空
    desc: {default: ''},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "DataInput",
  components: {
    MobileButton,
    YqIcon
  },
  data() {
    return {
      value: "",
      currentValue: "",
      showDrawer: false,
    };
  },
  computed: {
    // 传了默认插槽就用插槽内容当值区域（选择类 / 日期类控件）
    hasValueSlot() {
      return !!this.$slots.default;
    }
  },
  created() {
    this.init();
    watch(() => this.modelValue, () => this.init())
  },
  methods: {
    init() {
      this.value = this.modelValue;
    },
    toShowDrawer() {
      if (this.disabled) {
        return
      }
      this.currentValue = this.value;
      this.showDrawer = true;
    },
    toConfirmChange() {
      this.$emit("update:modelValue", this.currentValue);
      this.showDrawer = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.data-input{
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--yq-border-color);
  &:last-child{
    border-bottom: none;
  }
  .data-label{
    width: 120px;
    line-height: 70px;
    height: 70px;
  }
  .data-value{
    flex: 1;
    text-align: right;
    .placeholder{
      color: var(--yq-font-color-desc);
    }
  }
  .arrow{
    color: var(--el-color-primary);
    margin-left: 10px;
    width: 20px;
    &.disabled{
      color: var(--yq-font-color-desc);
    }
  }
  // 自定义控件（选择类 / 日期类）：值区域靠右显示
  &.custom-value{
    .data-value{
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
.input-container{
  margin: 20px;
  overflow: hidden;
  .input-area{
    //outline: none;
    //width: 100%;
    //height: 30px;
    //line-height: 30px;
    //border-color: transparent;
    //border-bottom-color: var(--yq-border-color);
    font-size: var(--yq-font-size-large-mobile);
  }
  .input-desc{
    font-size: var(--yq-font-size-small-mobile);
    color: var(--yq-font-color-desc);
    margin-top: 20px;
  }
  .input-button{
    margin-top: 60px;
  }
}

.drawer-title{
  font-size: var(--yq-font-size-large-mobile);
  color: var(--yq-font-color-base);
  font-weight: 600;
}
</style>